import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {IeditTeamMember} from '../../components/pages/user-management/models';
import {
  hasBulkUploadSummaryData,
  normalizeBulkUploadSummary,
} from '../../utils/bulkUserUploadUtlis';
export interface AddClientInfoFields {
  role: string;
  projectPermissionGroup?: string;
  clientPermissionGroup?: string;
  project?: string;
  workspace?: string;
}
interface ISummary {
  totalErrors?: number;
  totalUsers?: number;
  totalErrorUsers?: number;
  totalSuccessUsers?: number;
  totalExistingUser?: number;
}
interface TeamMemberState {
  teamMemberInfo: IeditTeamMember & AddClientInfoFields;
  userDataSummary: any;
  value: number;
  pageSize: number;
  showDrawer: boolean;
  dismissBanner: boolean;
  currentUser: {
    currentRow: number;
    totalRow: number;
    startRow: number;
    page: number;
    pageSize: number;
  };
  errors: Array<{
    field: any;
    message: string[];
  }>;
  summary: ISummary;
  isExistingUser: boolean;
  showToastIn: boolean;
  projectChange: boolean;
  tabType: string;
  fixErrorTab: boolean;
}

const initialState: TeamMemberState = {
  teamMemberInfo: {
    firstName: '',
    lastName: '',
    email: '',
    isBillable: false,
    isLimitIp: false,
    ipAddressList: [],
    role: '',
    projectPermissionGroup: '',
    clientPermissionGroup: '',
    project: '',
    userImportTempId: '',
    workspace: '',
  },
  showDrawer: false,
  dismissBanner: false,
  currentUser: {
    currentRow: 1,
    totalRow: 1,
    startRow: 1,
    page: 1,
    pageSize: 25,
  },
  errors: [],
  summary: {
    totalErrors: 0,
    totalUsers: 0,
    totalErrorUsers: 0,
    totalSuccessUsers: 0,
    totalExistingUser: 0,
  },
  userDataSummary: {
    firstName: '',
    lastName: '',
    email: '',
    isBillable: false,
    isLimitIp: false,
    ipAddressList: [],
    role: '',
    projectPermissionGroup: '',
    clientPermissionGroup: '',
    project: '',
    userImportTempId: '',
    workspace: '',
  },
  value: 0,
  pageSize: 25,
  isExistingUser: false,
  showToastIn: false,
  projectChange: false,
  tabType: '',
  fixErrorTab: false,
};

const bulkUserEditSlice = createSlice({
  name: 'bulkUserEdit',
  initialState,
  reducers: {
    setBulkUserEdit(
      state,
      action: PayloadAction<IeditTeamMember & AddClientInfoFields>
    ) {
      state.teamMemberInfo = {...action.payload};
    },
    setDrawer(state, action: PayloadAction<boolean>) {
      state.showDrawer = action.payload;
    },
    setDismissbanner(state, action: PayloadAction<boolean>) {
      state.dismissBanner = action.payload;
    },
    setCurrentRow(
      state,
      action: PayloadAction<{
        currentRow: number;
        totalRow: number;
        startRow: number;
        page: number;
        pageSize: number;
      }>
    ) {
      state.currentUser = action.payload;
    },
    setErrors(state, action: PayloadAction<any>) {
      state.errors = action.payload;
    },
    setSummary(state, action: PayloadAction<any>) {
      const normalized = normalizeBulkUploadSummary(action.payload);
      if (hasBulkUploadSummaryData(normalized)) {
        state.summary = normalized;
      } else if (!hasBulkUploadSummaryData(state.summary)) {
        state.summary = normalized;
      }
    },
    adjustSummaryAfterErrorResolved(
      state,
      action: PayloadAction<{resolvedErrorCount: number}>
    ) {
      const {resolvedErrorCount} = action.payload;
      state.summary.totalErrorUsers = Math.max(
        (state.summary.totalErrorUsers ?? 0) - 1,
        0
      );
      state.summary.totalErrors = Math.max(
        (state.summary.totalErrors ?? 0) - resolvedErrorCount,
        0
      );
      state.summary.totalSuccessUsers =
        (state.summary.totalSuccessUsers ?? 0) + 1;
    },
    setUserDataSummary(state, action: PayloadAction<any>) {
      state.userDataSummary = action.payload;
    },
    setValue(state, action: PayloadAction<number>) {
      state.value = action.payload;
    },
    setPageSize(state, action: PayloadAction<number>) {
      state.pageSize = action.payload;
    },
    setIsExistingUser(state, action: PayloadAction<any>) {
      state.isExistingUser = action.payload;
    },
    setShowToastIn(state, action: PayloadAction<any>) {
      state.showToastIn = action.payload;
    },
    setProjectChange(state, action: PayloadAction<boolean>) {
      state.projectChange = action.payload;
    },
    setTab(state, action: PayloadAction<string>) {
      state.tabType = action.payload;
    },
    setFixErrorTab(state, action: PayloadAction<boolean>) {
      state.fixErrorTab = action.payload;
    },
  },
});

export const {
  setBulkUserEdit,
  setDrawer,
  setDismissbanner,
  setCurrentRow,
  setErrors,
  setSummary,
  adjustSummaryAfterErrorResolved,
  setIsExistingUser,
  setShowToastIn,
  setProjectChange,
  setTab,
  setValue,
  setFixErrorTab,
  setUserDataSummary,
  setPageSize,
} = bulkUserEditSlice.actions;

export default bulkUserEditSlice.reducer;
